import {SIMPLIFIED_MODULE} from '../../constants/identifiers';
import reducers from './reducers';

export default [
    {
        id: SIMPLIFIED_MODULE,
        reducers
    }
];



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/index.js